import React, { Suspense } from 'react'
import { AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js'
import { Autocomplete, TextField, Skeleton } from '@mui/material'
import { useRecoilValue } from 'recoil'
import { DecimalSelectorItem } from '../../../api/generated'
import { reactPlugin } from '../../../infrastructure/ApplicationInsights'
import { Brands } from '../state/CurrentSensorPeriod'

export interface BrandSelectorProps {
  multiple: boolean
  disabled?: boolean
  value?: DecimalSelectorItem | DecimalSelectorItem[] | null
  onChange(product: DecimalSelectorItem | DecimalSelectorItem[] | null): void
}

export function BrandSelector(props: BrandSelectorProps) {
  return (
    <AppInsightsErrorBoundary onError={() => <p>No Brands</p>} appInsights={reactPlugin}>
      <Suspense fallback={<Skeleton variant='rectangular' width='25ch' />}>
        <BrandSelectorAsync {...props} />
      </Suspense>
    </AppInsightsErrorBoundary>
  )
}

export function BrandSelectorAsync(props: BrandSelectorProps) {
  const products = useRecoilValue(Brands)

  const handleSensorChange = (event: React.SyntheticEvent<Element, Event>, value: DecimalSelectorItem | DecimalSelectorItem[] | null) => {
    if (!value) return
    props.onChange(value)
  }

  return (
    <Autocomplete
      sx={{ width: '50ch' }}
      multiple={props.multiple}
      id='Brand-selector'
      disabled={props.disabled}
      disableCloseOnSelect
      autoComplete
      value={props.value}
      options={products}
      onChange={handleSensorChange}
      getOptionLabel={(option) => option.name ?? ''}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      filterSelectedOptions
      renderInput={(params) => <TextField {...params} label='Brands' />}
    />
  )
}
